import { SPRITE_SYMBOLS } from "@/assets/icons/sprite/IconSprite";
import { SpriteIcon } from "@/assets/icons/sprite/SpriteIcon";
import { IconProps } from "@/common/contracts/icon.contracts";

/* Sprite-backed: footer accordions, selects and facets repeat it; see `IconSprite`. */
export const ChevronDown = (props: IconProps) => {
  return (
    <SpriteIcon
      symbol={SPRITE_SYMBOLS.chevronDown}
      width="24"
      height="24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    />
  );
};
